// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"_12pCZ","imageWrapper":"_i-9y","caption":"U37n7","closeButton":"_3Ij03"};